import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import Dropzone from 'react-dropzone'

import Button from 'components/base/Button'
import { MAX_IMAGE_SIZE, IMAGE_ACCEPTED_TYPES } from 'data/medias/record'

import './style.css'
import { SpinnerIcon } from '../Icons'
const IMG_SIZE = 64

const PicInput = ({ help, src, onChange, updateState }) => {
  const picClassName =
    'picinput-img radius-round margin-bottom-normal pointer opacity-normal-on-hover shadow--small'

  return (
    <Dropzone
      activeClassName="picinput-active-drag"
      className="flexbox"
      style={{}}
      multiple={false}
      accept={IMAGE_ACCEPTED_TYPES}
      maxSize={MAX_IMAGE_SIZE}
      onDropAccepted={files => onChange(files[0])}
    >
      <div className="flexbox-no-grow padding-right-large">
        {src &&
          updateState.ongoing && (
            <div
              className={classNames(
                picClassName,
                'flexbox flexbox-align-center flexbox-centered'
              )}
              style={{
                width: IMG_SIZE,
                height: IMG_SIZE,
              }}
            >
              <SpinnerIcon className="spinner-rotating" />
            </div>
          )}
        {src &&
          !updateState.ongoing && (
            <div
              className={picClassName}
              style={{
                width: IMG_SIZE,
                height: IMG_SIZE,
                backgroundImage: `url(${src})`,
                backgroundSize: 'cover',
              }}
            />
          )}
        {!src && (
          <div
            className={classNames(picClassName, 'background-shade-40')}
            style={{
              width: IMG_SIZE,
              height: IMG_SIZE,
            }}
          />
        )}
      </div>
      <div className="flexbox-grow">
        <Button.Secondary>Upload a picture</Button.Secondary>
        {help && (
          <div className="shade-20 font-size-small padding-top-normal">
            {help}
          </div>
        )}
      </div>
    </Dropzone>
  )
}

PicInput.propTypes = {
  src: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default PicInput
